module.exports = __webpack_public_path__ + "static/media/26.9bb4e925.jpeg";